import { getDayHotelSearchPosition, getPositionCityId } from '@koob/utils';
import { ProductTypeEnum } from '@koob/enums';

// KD-3565 — the program search reopens empty on every day card. The
// destination prefill below answers "where does the traveller sleep", which
// is a hotel question; carrying it over to the program search would leave
// the field filled with a place the user did not ask for.
//
// KD-3548 — for a hotel slot, the transfer's destination is used rather than
// the program's end location. Resolves to the next program's start position
// when the destination is a point of interest with no city of its own; both
// name the same place.
export function getDayItemSearchLocation({
  type,
  days,
  dayIndex,
  experiencesMap,
  experience,
  program,
}: {
  type: string;
  days: any[];
  dayIndex: number;
  experiencesMap: Record<string, any> | undefined;
  experience: any;
  program: any;
}): any {
  if (type !== ProductTypeEnum.HOTEL) {
    return undefined;
  }

  const searchLocation = getDayHotelSearchPosition({
    days,
    dayIndex,
    experiencesMap,
    experience,
    program,
  });

  const searchLocationCityId = getPositionCityId(searchLocation);

  return searchLocationCityId
    ? [
        {
          id: searchLocationCityId,
          title: searchLocation.name,
          description: searchLocation.address,
          type: 'city',
          weight: 0,
          kind: 'city',
        },
      ]
    : undefined;
}
